<template>
  <div>
    <div
        class="text-center mt-16"
        v-if="dataFetching"
    >
      <v-progress-circular
          indeterminate
          color="primary"
      ></v-progress-circular>
    </div>

    <v-alert
        color="grey"
        text
        v-if="redeemables.length === 0"
    >No redeemable record found
    </v-alert>

    <PaginatedList
        v-if="redeemables.length > 0"
        :items="redeemables"
        :itemsPerPage="5"
        :pageChangeCallback="paginatedListPageChangeCallback"
    >
      <template v-slot:content="{items, itemsPerPage, page}">
        <v-card
            v-for="(redeemable, index) in items"
            :key="index"
            class="mb-4"
        >
          <v-row class="ma-0 pa-0 align-center" v-if="nfts[itemsPerPage * (page - 1) + index]">
            <v-col
                class="col-12 col-sm-4"
            >
              <v-responsive :aspect-ratio="1" class="align-center justify-center">
                <v-img
                    :src="nfts[itemsPerPage * (page - 1) + index].imageUrl"
                    contain
                ></v-img>
              </v-responsive>
            </v-col>

            <v-col class="col-12 col-sm-8">
              <v-card-text>
                <div class="d-flex justify-space-between">
                  <div class="title">{{ nfts[itemsPerPage * (page - 1) + index].name }}</div>
                  <slot name="topRightBtn" v-bind="{redeemable, itemsPerPage, page, index}"></slot>
                </div>

                <div class="my-4">
                  {{ nfts[itemsPerPage * (page - 1) + index].description }}
                </div>

                <h5>Attributes:</h5>
                <v-sheet
                    color="grey lighten-3"
                    class="pa-2 mt-2"
                    v-for="(trait, index) in nfts[itemsPerPage * (page - 1) + index].attributes"
                    :key="index"
                >
                  <div class="d-flex justify-space-between">
                    <div>
                      {{trait.trait_type}}
                    </div>
                    <div>
                      {{trait.value}}
                    </div>
                  </div>
                </v-sheet>


                <div class="d-flex justify-space-between mt-2">
                  <div>External Url</div>
                  <div>
                    {{ nfts[itemsPerPage * (page - 1) + index].externalUrl === ""
                      ? "-" : nfts[itemsPerPage * (page - 1) + index].externalUrl
                    }}</div>
                </div>

                <v-divider class="my-4"></v-divider>
                <div class="d-flex justify-space-between">
                  <div>Redeemable Id</div>
                  <div>{{ redeemable.redeemableId }}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Token Id</div>
                  <div>{{ redeemable.tokenId }}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Reward scores required</div>
                  <div>{{ redeemable.requiredRewardScore / (10 ** paymentTokenDecimal) }}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Edition</div>
                  <div>
                    {{ redeemable.currentSupply }} / {{ redeemable.maxSupply === "0" ? '-' : redeemable.maxSupply }}
                  </div>
                </div>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </PaginatedList>
  </div>
</template>

<script>
import PaginatedList from "@/components/PaginatedList";
import config from "@/config";
import backendCall from "@/lib/backendCall";
export default {
  name: "RedeemableList",
  components: {
    PaginatedList
  },
  props: {
    storeAccount: String
  },
  computed: {
    paymentTokenDecimal() {
      return config.commonConfig.paymentCoinDecimal
    }
  },
  mounted() {
    this.fetchData()
  },
  data(){
    return {
      nftContract: "",
      redeemables: [],
      nfts: [],
      dataFetching: false
    }
  },
  methods: {
    async fetchData() {
      await this.fetchRedeemablePageData()
      // await this.fetchNftData()
    },
    async fetchRedeemablePageData() {
      try {
        const res = await backendCall.redeemable.getRedeemablePageData(this.storeAccount)
        if (res.status === 1) {
          if (res.data) {
            const {nftContract, redeemable} = res.data
            this.nftContract = nftContract
            this.redeemables = redeemable
          }
        }else {
          throw Error(res.message)
        }
      }catch (e) {
        console.error(e)
      }
    },
    // async fetchNftData(){
    //   this.dataFetching = true
    //   let promiseArray = []
    //   for (let i=0; i<this.redeemables.length; i++) {
    //     promiseArray.push(backendCall.nft.getNftMetadata(this.nftContract, this.redeemables[i].tokenId))
    //   }
    //   try {
    //     const promiseArrayRes = await Promise.all(promiseArray)
    //     for (let i = 0; i < promiseArrayRes.length; i++) {
    //       console.log(promiseArrayRes[i].status)
    //       console.log(promiseArrayRes[i].data)
    //       this.$set(this.nfts, i, (promiseArrayRes[i].status === 1 && promiseArrayRes[i].data) ? promiseArrayRes[i].data : null)
    //     }
    //   }catch (e) {
    //     console.error(e)
    //   } finally {
    //     this.dataFetching = false
    //   }
    // },
    paginatedListPageChangeCallback(items, page, itemsPerPage) {
      console.log("-------", this.redeemables)
      for (let i=((page-1) * itemsPerPage); i<page*itemsPerPage && i<this.redeemables.length; i++) {
        if (!this.nfts[i]) {
          backendCall.nft.getNftMetadata(
              this.nftContract,
              this.redeemables[i].tokenId
          ).then((res) => {
            if (res.status === 1){
              this.$set(this.nfts, i, res.data)
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>